import { Component, Input, OnInit } from '@angular/core';
import { DynamicEntryComponent, DynamicEntryComponentCrmConfig, DynamicOptionsComponent } from '../dynamic-options';
import { BehaviorSubject } from 'rxjs';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DatetimePickerComponent } from '../../../../../../common/components/datetime-picker/datetime-picker.component';

@Component({
  selector: 'automata-date-input',
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
  imports: [CommonModule, TranslateModule, DatetimePickerComponent],
})
export class DateInputComponent implements DynamicOptionsComponent, OnInit, DynamicEntryComponent {
  @Input() initialValue: Date;
  @Input() showVariableItemMenu: boolean;
  @Input() label: string;
  @Input() config: DynamicEntryComponentCrmConfig;
  @Input() required = false;

  selectedValue$$ = new BehaviorSubject<Date>(null);
  selectedValue$ = this.selectedValue$$.asObservable();
  selectedDate: Date = null;
  valid = true;
  initialDateValue: Date;

  ngOnInit(): void {
    // if value is empty or the initial value has already been initialized and cannot be parsed as a date,
    // reset date initial value.
    const timestamp = Date.parse(this.initialValue?.toString());
    if (this.initialValue == null || isNaN(timestamp) === true) {
      this.initialValue = new Date();
      this.initialValue.setHours(0, 0, 0, 0);
    }
    this.initialDateValue = new Date(this.initialValue);
    this.selectedValue$$.next(this.initialDateValue);
  }

  onSelectedDate(value: Date): void {
    this.selectedDate = value;
    this.selectedValue$$.next(value);
  }

  getSelectedValue(): Date {
    return this.selectedDate || this.initialDateValue;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [];
  }

  isFormValid(): boolean {
    const validDate = this.selectedDate || this.initialDateValue;
    return validDate != null && !isNaN(validDate.getDate());
  }
}
